import Phaser from "phaser";
import Level1 from "../components/levels/level_1";
import Level2 from "../components/levels/level_2";
import Level3 from "../components/levels/level_3";
import Level4 from "../components/levels/level_4";
import Level5 from "../components/levels/level_5";
import Level6 from "../components/levels/level_6";
import Level7 from "../components/levels/level_7";
import Level8 from "../components/levels/level_8";
import Level9 from "../components/levels/level_9";
import Level10 from "../components/levels/level_10";
import Level11 from "../components/levels/level_11";
import Level12 from "../components/levels/level_12";
import Level13 from "../components/levels/level_13";
import Level14 from "../components/levels/level_14";
import Level15 from "../components/levels/level_15";
import Level16 from "../components/levels/level_16";
import Level17 from "../components/levels/level_17";
import Level18 from "../components/levels/level_18";
import LevelFinale from "../components/levels/level_finale";
import LevelTest from "../components/levels/level_ki_finale";
import UIMenus from "../components/UIMenus";
import CRTFilter from "../utils/CRTShaderFX";
import LoadingBar from "../components/LoadingBar/LoadingBar";
import { SCALE } from "../utils/constants";
import { translate } from "../utils/localization";

let titlesMusic;
export default class LandingScene extends Phaser.Scene {
  constructor() {
    super("LandingScene");
  }

  preload() {
    this.cameras.main.setPostPipeline(CRTFilter);

    const bar = new LoadingBar(this);

    this.load.on("progress", function (value) {
      bar.setValue(value);
    });

    this.load.on("complete", function () {
      window.WebFont.load({
        custom: {
          families: ["GameGirl", "Emulogic"],
        },
        active: () => {
          bar.setValue(1);
        },
      });
      // onLoadingComplete()
    });

    // const txt = this.add
    //   .text(
    //     80 * SCALE(),
    //     121 * SCALE() + 20 * SCALE(),
    //     translate("menu.main.loading_message"),
    //     // https://en.wikipedia.org/wiki/Sumerian_language

    //     // 𒉆  𒅗𒈠    𒋛𒀀𒋛𒀀𒂠       𒂊𒀝
    //     // nam  inim-ma  diri-diri-še3  e-ak
    //     // acted unspeakably

    //     // 𒄑𒆵𒆠𒁕   𒁮𒄩𒊏    𒂊𒁕𒀝
    //     // ummaki-da  dam-ḫa-ra  e-da-ak

    //     {
    //       fontFamily: "GameGirl",
    //       fontSize: "40px",
    //       fill: "#ffffff",
    //     }
    //   )
    //   .setShadow(-1, 1);

    // txt.setScale(SCALE() / 5);
    this.load.script(
      "webfont",
      "https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js"
    );
    // this.load.image('main-tiles', process.env.PUBLIC_URL + '/assets/tilemaps/tilemap_20x20.png');
    this.load.image(
      "main-tiles",
      process.env.PUBLIC_URL + "/assets/tilemaps/world1_tiles_20x20.png"
    );
    this.load.image(
      "gates-tiles",
      process.env.PUBLIC_URL + "/assets/tilemaps/gates_tilemap_20x20.png"
    );
    this.load.image(
      "hud-tiles",
      process.env.PUBLIC_URL + "/assets/tilemaps/hud_tilemap_20x20.png"
    );
    this.load.image(
      LevelTest.key,
      process.env.PUBLIC_URL + "/assets/maps/level_19.png"
    );
    this.load.image(
      `${LevelTest.key}_bg`,
      process.env.PUBLIC_URL + "/assets/maps/level_19_bg.png"
    );
    this.load.image(
      Level1.key,
      process.env.PUBLIC_URL + "/assets/maps/level_1.png"
    );
    this.load.image(
      `${Level1.key}_bg`,
      process.env.PUBLIC_URL + "/assets/maps/level_1_bg.png"
    );
    this.load.image(
      Level2.key,
      process.env.PUBLIC_URL + "/assets/maps/level_2.png"
    );
    this.load.image(
      `${Level2.key}_bg`,
      process.env.PUBLIC_URL + "/assets/maps/level_2_bg.png"
    );
    this.load.image(
      Level3.key,
      process.env.PUBLIC_URL + "/assets/maps/level_3.png"
    );
    this.load.image(
      `${Level3.key}_bg`,
      process.env.PUBLIC_URL + "/assets/maps/level_3_bg.png"
    );
    this.load.image(
      Level4.key,
      process.env.PUBLIC_URL + "/assets/maps/level_4.png"
    );
    this.load.image(
      `${Level4.key}_bg`,
      process.env.PUBLIC_URL + "/assets/maps/level_default_bg.png"
    );
    this.load.image(
      Level5.key,
      process.env.PUBLIC_URL + "/assets/maps/level_5.png"
    );
    this.load.image(
      `${Level5.key}_bg`,
      process.env.PUBLIC_URL + "/assets/maps/level_default_bg.png"
    );
    this.load.image(
      Level6.key,
      process.env.PUBLIC_URL + "/assets/maps/level_6.png"
    );
    this.load.image(
      `${Level6.key}_bg`,
      process.env.PUBLIC_URL + "/assets/maps/level_default_bg.png"
    );
    this.load.image(
      Level7.key,
      process.env.PUBLIC_URL + "/assets/maps/level_7.png"
    );
    this.load.image(
      `${Level7.key}_bg`,
      process.env.PUBLIC_URL + "/assets/maps/level_default_bg.png"
    );
    this.load.image(
      Level8.key,
      process.env.PUBLIC_URL + "/assets/maps/level_8.png"
    );
    this.load.image(
      `${Level8.key}_bg`,
      process.env.PUBLIC_URL + "/assets/maps/level_default_bg.png"
    );
    this.load.image(
      Level9.key,
      process.env.PUBLIC_URL + "/assets/maps/level_9.png"
    );
    this.load.image(
      `${Level9.key}_bg`,
      process.env.PUBLIC_URL + "/assets/maps/level_default_bg.png"
    );
    this.load.image(
      Level10.key,
      process.env.PUBLIC_URL + "/assets/maps/level_10.png"
    );
    this.load.image(
      `${Level10.key}_bg`,
      process.env.PUBLIC_URL + "/assets/maps/level_default_bg.png"
    );
    this.load.image(
      Level11.key,
      process.env.PUBLIC_URL + "/assets/maps/level_11.png"
    );
    this.load.image(
      `${Level11.key}_bg`,
      process.env.PUBLIC_URL + "/assets/maps/level_default_bg.png"
    );
    this.load.image(
      Level12.key,
      process.env.PUBLIC_URL + "/assets/maps/level_12.png"
    );
    this.load.image(
      `${Level12.key}_bg`,
      process.env.PUBLIC_URL + "/assets/maps/level_default_bg.png"
    );
    this.load.image(
      Level13.key,
      process.env.PUBLIC_URL + "/assets/maps/level_13.png"
    );
    this.load.image(
      `${Level13.key}_bg`,
      process.env.PUBLIC_URL + "/assets/maps/level_default_bg.png"
    );
    this.load.image(
      Level14.key,
      process.env.PUBLIC_URL + "/assets/maps/level_14.png"
    );
    this.load.image(
      `${Level14.key}_bg`,
      process.env.PUBLIC_URL + "/assets/maps/level_default_bg.png"
    );
    this.load.image(
      Level15.key,
      process.env.PUBLIC_URL + "/assets/maps/level_15.png"
    );
    this.load.image(
      `${Level15.key}_bg`,
      process.env.PUBLIC_URL + "/assets/maps/level_default_bg.png"
    );
    this.load.image(
      Level16.key,
      process.env.PUBLIC_URL + "/assets/maps/level_16.png"
    );
    this.load.image(
      `${Level16.key}_bg`,
      process.env.PUBLIC_URL + "/assets/maps/level_default_bg.png"
    );
    this.load.image(
      Level17.key,
      process.env.PUBLIC_URL + "/assets/maps/level_17.png"
    );
    this.load.image(
      `${Level17.key}_bg`,
      process.env.PUBLIC_URL + "/assets/maps/level_default_bg.png"
    );
    this.load.image(
      Level18.key,
      process.env.PUBLIC_URL + "/assets/maps/level_18.png"
    );
    this.load.image(
      `${Level18.key}_bg`,
      process.env.PUBLIC_URL + "/assets/maps/level_default_bg.png"
    );
    this.load.image(
      LevelFinale.key,
      process.env.PUBLIC_URL + "/assets/maps/level_finale.png"
    );
    this.load.image(
      "Stage1_bg",
      process.env.PUBLIC_URL + "/assets/images/stage_1_bg_art.png"
    );
    this.load.image(
      "IntroTiamat",
      process.env.PUBLIC_URL + "/assets/images/intro_tiamat.png"
    );
    this.load.image(
      "IntroSky",
      process.env.PUBLIC_URL + "/assets/images/intro_sky.png"
    );
    this.load.image(
      "IntroClouds",
      process.env.PUBLIC_URL + "/assets/images/intro_clouds.png"
    );
    this.load.image(
      "IntroGround",
      process.env.PUBLIC_URL + "/assets/images/intro_ground.png"
    );
    this.load.image(
      "IntroGroundHigh",
      process.env.PUBLIC_URL + "/assets/images/intro_ground_high.png"
    );
    this.load.image(
      "IntroGroundBreak",
      process.env.PUBLIC_URL + "/assets/images/intro_ground_break.png"
    );
    this.load.image(
      "IntroComet",
      process.env.PUBLIC_URL + "/assets/images/intro_comet.png"
    );
    this.load.image(
      "IntroPeopleClimbing",
      process.env.PUBLIC_URL + "/assets/images/intro_people_climbing.png"
    );
    this.load.image(
      "IntroPeoplePraying",
      process.env.PUBLIC_URL + "/assets/images/intro_people_praying.png"
    );
    this.load.image(
      "IntroPeoplePrayingHigh",
      process.env.PUBLIC_URL + "/assets/images/intro_people_praying_high.png"
    );
    this.load.image(
      "IntroPeopleDescending",
      process.env.PUBLIC_URL + "/assets/images/intro_people_descending.png"
    );
    this.load.image(
      "IntroPeopleFalling",
      process.env.PUBLIC_URL + "/assets/images/intro_people_falling.png"
    );
    this.load.image(
      "IntroPeopleJumping",
      process.env.PUBLIC_URL + "/assets/images/intro_people_jumping.png"
    );
    this.load.image(
      "IntroStorm",
      process.env.PUBLIC_URL + "/assets/images/intro_storm.png"
    );
    this.load.image(
      "Prologue",
      process.env.PUBLIC_URL + "/assets/images/Prologue.png"
    );
    this.load.image(
      "thechild",
      process.env.PUBLIC_URL + "/assets/images/thechild.png"
    );
    this.load.image(
      "theworld",
      process.env.PUBLIC_URL + "/assets/images/theworld.png"
    );
    this.load.image(
      "Tiamat",
      process.env.PUBLIC_URL + "/assets/images/Tiamat.png"
    );
    this.load.image(
      "Cover",
      process.env.PUBLIC_URL + "/assets/images/cover.png"
    );
    this.load.image(
      "Bossfight",
      process.env.PUBLIC_URL + "/assets/images/Bossfight.png"
    );
    this.load.image(
      "Bossfighthands",
      process.env.PUBLIC_URL + "/assets/images/Bossfighthands.png"
    );
    this.load.image(
      "spark",
      process.env.PUBLIC_URL + "/assets/sprites/flare_blue.png"
    );
    this.load.image(
      "light_beam",
      process.env.PUBLIC_URL + "/assets/sprites/light_beam.png"
    );
    this.load.spritesheet(
      "boulder",
      process.env.PUBLIC_URL + "/assets/sprites/boulder_sprite.png",
      { frameWidth: 26, frameHeight: 26 }
    );
    this.load.spritesheet(
      "explosion",
      process.env.PUBLIC_URL + "/assets/sprites/explosion_sprite.png",
      { frameWidth: 26, frameHeight: 26 }
    );
    this.load.spritesheet(
      "torch",
      process.env.PUBLIC_URL + "/assets/sprites/torch_sprite.png",
      { frameWidth: 26, frameHeight: 26 }
    );
    this.load.spritesheet(
      "brave",
      process.env.PUBLIC_URL + "/assets/sprites/brave_sprite.png",
      { frameWidth: 26, frameHeight: 26 }
    );
    this.load.spritesheet(
      "bro",
      process.env.PUBLIC_URL + "/assets/sprites/bro_sprite.png",
      { frameWidth: 26, frameHeight: 26 }
    );
    this.load.spritesheet(
      "dwarf",
      process.env.PUBLIC_URL + "/assets/sprites/dwarf_sprite.png",
      { frameWidth: 26, frameHeight: 26 }
    );
    this.load.spritesheet(
      "boss",
      process.env.PUBLIC_URL + "/assets/sprites/boss_sprite.png",
      { frameWidth: 20, frameHeight: 20 }
    );
    this.load.spritesheet(
      "gate",
      process.env.PUBLIC_URL + "/assets/sprites/gate_sprite.png",
      { frameWidth: 26, frameHeight: 26 }
    );
    this.load.spritesheet(
      "bat",
      process.env.PUBLIC_URL + "/assets/sprites/bat_sprite.png",
      { frameWidth: 26, frameHeight: 26 }
    );
    this.load.spritesheet(
      "pickables",
      process.env.PUBLIC_URL + "/assets/sprites/pickables_sprite.png",
      { frameWidth: 26, frameHeight: 26 }
    );
    this.load.spritesheet(
      "closeUp",
      process.env.PUBLIC_URL + "/assets/sprites/close_up_sprite.png",
      { frameWidth: 40, frameHeight: 40 }
    );
    this.load.spritesheet(
      "closeUpItems",
      process.env.PUBLIC_URL + "/assets/sprites/close_up_sprite.png",
      { frameWidth: 20, frameHeight: 20 }
    );
    this.load.audio(
      "credits",
      process.env.PUBLIC_URL + "/assets/audio/Score/Opening Credits_.mp3"
    );
    this.load.audio(
      "opening_peace",
      process.env.PUBLIC_URL + "/assets/audio/Score/NormalDay.mp3"
    );
    this.load.audio(
      "opening_quakes",
      process.env.PUBLIC_URL + "/assets/audio/Score/Earthquakes+Tiamat.mp3"
    );
    this.load.audio(
      "credits",
      process.env.PUBLIC_URL + "/assets/audio/Score/NormalDay.mp3"
    );
    this.load.audio(
      "levels_surface",
      process.env.PUBLIC_URL + "/assets/audio/Score/1st 7 Levels.mp3"
    );
    this.load.audio(
      "swarf_chat_music",
      process.env.PUBLIC_URL +
        "/assets/audio/Score/MushroomDwarfDialogue(loop).mp3"
    );
    this.load.audio(
      "generic_chat_music",
      process.env.PUBLIC_URL + "/assets/audio/Score/GenericDialogue(loop).mp3"
    );
    this.load.audio(
      "escape_music",
      process.env.PUBLIC_URL +
        "/assets/audio/Score/BossBattle_EscapeTheVoid!(loop).mp3"
    );
    this.load.audio(
      "rock_hit",
      process.env.PUBLIC_URL + "/assets/audio/SFX/RockHit.mp3"
    );
    this.load.audio(
      "rock_hit2",
      process.env.PUBLIC_URL + "/assets/audio/SFX/RockHit2.mp3"
    );
    this.load.audio(
      "rock_hit3",
      process.env.PUBLIC_URL + "/assets/audio/SFX/RockHit3.wav"
    );
    this.load.audio(
      "rock_hit_soft",
      process.env.PUBLIC_URL + "/assets/audio/SFX/RockHitSoft.mp3"
    );
    this.load.audio(
      "explosion",
      process.env.PUBLIC_URL + "/assets/audio/SFX/MidSizeExplosion.mp3"
    );
    this.load.audio(
      "clear_hit1",
      process.env.PUBLIC_URL + "/assets/audio/SFX/PickaxeClearingGround1.mp3"
    );
    this.load.audio(
      "clear_hit2",
      process.env.PUBLIC_URL + "/assets/audio/SFX/PickaxeClearingGround2.mp3"
    );
    this.load.audio(
      "clear_hit3",
      process.env.PUBLIC_URL + "/assets/audio/SFX/PickaxeClearingGround3.mp3"
    );
    this.load.audio(
      "rock_slide_hard1",
      process.env.PUBLIC_URL + "/assets/audio/SFX/RockSlideHard1.mp3"
    );
    this.load.audio(
      "rock_slide_hard2",
      process.env.PUBLIC_URL + "/assets/audio/SFX/RockSlideHard2.mp3"
    );
    this.load.audio(
      "rock_slide_hard3",
      process.env.PUBLIC_URL + "/assets/audio/SFX/RockSlideHard3.mp3"
    );
    this.load.audio(
      "rock_slide_soft1",
      process.env.PUBLIC_URL + "/assets/audio/SFX/RockSlideSoft1.mp3"
    );
    this.load.audio(
      "rock_slide_soft2",
      process.env.PUBLIC_URL + "/assets/audio/SFX/RockSlideSoft2.mp3"
    );
    this.load.audio(
      "rock_slide_soft3",
      process.env.PUBLIC_URL + "/assets/audio/SFX/RockSlideSoft3.mp3"
    );
    this.load.audio(
      "coin",
      process.env.PUBLIC_URL + "/assets/audio/SFX/CoinSound.mp3"
    );
    this.load.audio(
      "gem_hit",
      process.env.PUBLIC_URL + "/assets/audio/SFX/GemHitRock.mp3"
    );
    this.load.audio(
      "shroom_pick",
      process.env.PUBLIC_URL + "/assets/audio/SFX/MushroomPickUp.mp3"
    );
    this.load.audio(
      "gem_pick",
      process.env.PUBLIC_URL + "/assets/audio/SFX/DiamondPickUp.mp3"
    );
    this.load.audio(
      "death_by_rock",
      process.env.PUBLIC_URL + "/assets/audio/SFX/DeathByRock.mp3"
    );
    this.load.audio(
      "level_complete",
      process.env.PUBLIC_URL + "/assets/audio/SFX/Level Finish.mp3"
    );
    this.load.audio(
      "earthquake",
      process.env.PUBLIC_URL + "/assets/audio/SFX/Earthquake.mp3"
    );
    // this.load.on(Phaser.Loader.Events.PROGRESS, console.log)
  }

  navigateToScene(sceneId, props = {}) {
    this.cameras.main.fade(500, 0, 0, 0);
    this.cameras.main.once("camerafadeoutcomplete", () => {
      this.scene.start(sceneId, props);
    });
    // this.tweens.add({
    //   targets: titlesMusic,
    //   volume: 0,
    //   ease: "Linear",
    //   duration: 500,
    //   onComplete: () => {
    //     titlesMusic.pause();
    //     console.log(sceneId);
    //     this.scene.start(sceneId, props);
    //   },
    // });
  }

  create() {
    // this.cameras.main.setBackgroundColor("#486859")
    // this.cameras.main.setBackgroundColor("#000");

    const txt = this.add
      .text(
        80 * SCALE(),
        121 * SCALE() + 20 * SCALE(),
        translate('menu.main.key_to_start'),
        // https://en.wikipedia.org/wiki/Sumerian_language

        // 𒉆  𒅗𒈠    𒋛𒀀𒋛𒀀𒂠       𒂊𒀝
        // nam  inim-ma  diri-diri-še3  e-ak
        // acted unspeakably

        // 𒄑𒆵𒆠𒁕   𒁮𒄩𒊏    𒂊𒁕𒀝
        // ummaki-da  dam-ḫa-ra  e-da-ak

        {
          fontFamily: "GameGirl",
          fontSize: "40px",
          fill: "#ffffff",
        }
      )
      .setShadow(-1, 1);

    txt.setScale(SCALE() / 5);

    this.input.keyboard.on("keydown", (event) => {
      this.navigateToScene("SplashScreenScene");
      // window.document.addEventListener('fullscreenchange', () => {
      //   if(document.fullscreenElement === null) {
      //     window.location.reload()
      //   }
      // });
      // if (event.key === "Enter" && !this.scale.isFullscreen) {
      //   this.scale.startFullscreen();
      //   this.navigateToScene("SplashScreenScene");
      //   this.input.keyboard.off("keydown");
      // }
    });

    // let image = this.add.image(
    //   this.cameras.main.width / 2,
    //   this.cameras.main.height / 2,
    //   "Cover"
    // );
    // let image = this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 3, 'Cover')
    // let scaleX = this.cameras.main.width / image.width;
    // let scaleY = this.cameras.main.height / image.height;
    // let scale = Math.min(scaleX, scaleY);
    // image.setOrigin(0.5, 0.5);
    // image.setScale(scale).setScrollFactor(0);
    // // image.setScale(scale * 1.5).setScrollFactor(0)
    // image.name = "background_art";

    // this.tweens.add({
    //   targets: circularProgress,
    //   value: 0.75,
    //   duration: 2000,
    //   ease: "Cubic",
    // });

    // this.anims.create({
    //   key: "explosion_explode",
    //   frames: this.anims.generateFrameNumbers("explosion", {
    //     frames: [0, 1, 2, 3, 4, 5, 6, 7],
    //   }),
    //   frameRate: 1,
    //   repeat: 0,
    // });

    // const explosion = this.add.sprite(48, 16).setOrigin(0.125, 0.125).play('explosion_explode')
    // explosion.setScale(SCALE())
    // explosion.x = explosion.y + 200

    // off-line version
    // this.cameras.main.fadeIn(500, 0, 0, 0)
    // this.events.emit('scene_ready', this.sys.config)
    // const menu = new UIMenus(this)
    // menu.showInitialMenu()
    // titlesMusic = this.sound.add('credits', { loop: true });
    // return false

    // titlesMusic = this.sound.add("credits", { loop: true });
    // window.WebFont.load({
    //   custom: {
    //     families: ["GameGirl", "Emulogic"],
    //   },
    //   active: () => {
    // this.cameras.main.fadeIn(500, 0, 0, 0);
    // this.events.emit("scene_ready", this.sys.config);

    // titlesMusic = this.sound.add("credits", { loop: true });
    // titlesMusic.play()

    // this.events.once(Phaser.Scenes.Events.WAKE, () => console.log(Phaser.Scenes.Events.WAKE))
    // this.events.once(Phaser.Scenes.Events.UPDATE, () => console.log(Phaser.Scenes.Events.UPDATE))
    // this.events.once(Phaser.Scenes.Events.TRANSITION_WAKE, () => console.log(Phaser.Scenes.Events.TRANSITION_WAKE))
    // this.events.once(Phaser.Scenes.Events.TRANSITION_START, () => console.log(Phaser.Scenes.Events.TRANSITION_START))
    // this.events.once(Phaser.Scenes.Events.TRANSITION_OUT, () => console.log(Phaser.Scenes.Events.TRANSITION_OUT))
    // this.events.once(Phaser.Scenes.Events.TRANSITION_INIT, () => console.log(Phaser.Scenes.Events.TRANSITION_INIT))
    // this.events.once(Phaser.Scenes.Events.TRANSITION_COMPLETE, () => console.log(Phaser.Scenes.Events.TRANSITION_COMPLETE))
    // this.events.once(Phaser.Scenes.Events.START, () => console.log(Phaser.Scenes.Events.START))
    // this.events.once(Phaser.Scenes.Events.SLEEP, () => console.log(Phaser.Scenes.Events.SLEEP))
    // this.events.once(Phaser.Scenes.Events.SHUTDOWN, () => console.log(Phaser.Scenes.Events.SHUTDOWN))
    // this.events.once(Phaser.Scenes.Events.RESUME, () => console.log(Phaser.Scenes.Events.RESUME))
    // this.events.once(Phaser.Scenes.Events.RENDER, () => console.log(Phaser.Scenes.Events.RENDER))
    // this.events.once(Phaser.Scenes.Events.READY, () => console.log(Phaser.Scenes.Events.READY))
    // this.events.once(Phaser.Scenes.Events.PRE_RENDER, () => console.log(Phaser.Scenes.Events.PRE_RENDER))
    // this.events.once(Phaser.Scenes.Events.PAUSE, () => console.log(Phaser.Scenes.Events.PAUSE))
    // this.events.once(Phaser.Scenes.Events.CREATE, () => console.log(Phaser.Scenes.Events.CREATE))
    // this.events.once(Phaser.Scenes.Events.BOOT, () => console.log(Phaser.Scenes.Events.BOOT))

    // let currentOption = 0

    // const arrow = this.add.graphics({ fillStyle: { color: 0xffffff, alpha: 1 } })
    // arrow.fillTriangle(0, 0, 5, 5, 0, 10).setPosition(70 * SCALE, 27 * SCALE)
    // // arrow.setPosition(70 * SCALE, ((12 * newOption) + 2) * SCALE)
    // arrow.setScale(SCALE)

    // const menu = new UIMenus(this);
    // menu.showInitialMenu();

    // menuOptions.forEach((o, idx) => {
    //   const txt = this.add.text(80 * SCALE, (14 * idx + 1) * SCALE + 20 * SCALE,
    //     o.label,
    //     {
    //       fontFamily: 'GameGirl',
    //       // fontSize: "14px",
    //       fill: "#ffffff",
    //     }
    //   ).setVisible(!o.disabled)
    //   txt.displayHeight = 10 * SCALE
    //   txt.setScale(SCALE)
    //   // txt.displayWidth = idx * 10 * SCALE

    // })

    // this.input.keyboard.on('keydown', event => {
    //   let newOption = false
    //   if (event.key === 'ArrowUp') {
    //     newOption = currentOption > 0 ? currentOption - 1 : menuOptions.length - 1
    //   }
    //   if (event.key === 'ArrowDown') {
    //     newOption = currentOption < menuOptions.length - 1 ? currentOption + 1 : 0
    //   }
    //   if(newOption !== false && !menuOptions[newOption].disabled) {
    //     const INIT_OFFSET = 27 * SCALE
    //     arrow.setPosition(70 * SCALE, (14 * newOption) * SCALE + INIT_OFFSET)
    //     currentOption = newOption
    //   }
    //   if (event.key === 'Enter') {
    //     if(!menuOptions[currentOption].disabled) {
    //       menuOptions[currentOption].onSelect()
    //     }
    //   }
    // })
    // },
    // });
  }
}
